
import { formatClock, formatClockRange, toInstant, type Instant } from '@shared/tz';

export function viewerTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    return '';
  }
}

export function formatViewerTime(instant: Instant): string {
  return formatClock(instant, viewerTimeZone());
}

export function formatViewerDate(
  instant: Instant,
  options: Intl.DateTimeFormatOptions = { weekday: 'short', month: 'short', day: 'numeric' },
): string {
  return new Intl.DateTimeFormat('en-US', { ...options, timeZone: viewerTimeZone() }).format(
    toInstant(instant),
  );
}

export function formatViewerRange(start: Instant, end: Instant): string {
  return formatClockRange(start, end, viewerTimeZone());
}

export function viewerZoneLabel(instant: Instant = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZoneName: 'short',
    timeZone: viewerTimeZone() || undefined,
  }).formatToParts(toInstant(instant));
  return parts.find((p) => p.type === 'timeZoneName')?.value ?? '';
}
